import { queueMessage } from "~shared/snackbarsProvider/actions";
import { Action, createAction, handleActions } from "redux-actions";
import { DateRange } from "~api/types";
import { FechaField, Services } from "../types";
import { downloadFromUrl } from "../downloadFromUrl";

export interface GetEmisionesState {
  fechaDesdeSelected: FechaField;
  fechaHastaSelected: FechaField;
  buttonEnabled: boolean;
  buttonText: string;
  buttonComisionesText: string;
  errorMessage?: string;
}

const getEmisionesInited = createAction(
  "GET_REPORTE_EMISIONES_INITED",
  (data: DateRange) => ({ data })
);
const getEmisionesCompleted = createAction("GET_REPORTE_EMISIONES_COMPLETED");
const getEmisionesFailed = createAction(
  "GET_REPORTE_EMISIONES_FAILED",
  (error: any) => ({ error })
);

const getEmisionesDeComisionesInited = createAction(
  "GET_REPORTE_EMISIONES_DE_COMISIONES_INITED",
  (data: DateRange) => ({ data })
);
const getEmisionesDeComisionesCompleted = createAction(
  "GET_REPORTE_EMISIONES_DE_COMISIONES_COMPLETED"
);
const getEmisionesDeComisionesFailed = createAction(
  "GET_REPORTE_EMISIONES_DE_COMISIONES_FAILED",
  (error: any) => ({ error })
);

const setFechaDesde = createAction(
  "SET_FECHA_DESDE",
  (fechaDesdeSelected: FechaField) => ({
    fechaDesdeSelected,
  })
);
const setFechaHasta = createAction(
  "SET_FECHA_HASTA",
  (fechaHastaSelected: FechaField) => ({
    fechaHastaSelected,
  })
);

const date = new Date();
const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
const getEmisionesInitialState: GetEmisionesState = {
  fechaDesdeSelected: { value: firstDayOfMonth, valid: true, focus: false },
  fechaHastaSelected: { value: lastDayOfMonth, valid: false, focus: false },
  buttonEnabled: true,
  buttonText: "Descargar",
  buttonComisionesText: "Descargar (Comisiones)",
};

const getEmisionesReducer = handleActions<GetEmisionesState, any>(
  {
    [getEmisionesInited.toString()]: (state) => {
      return {
        ...state,
        buttonEnabled: false,
        buttonText: "Descargando...",
      };
    },
    [getEmisionesCompleted.toString()]: (state) => {
      return {
        ...state,
        buttonEnabled: true,
        buttonText: "Descargar",
      };
    },
    [getEmisionesFailed.toString()]: (
      state,
      action: Action<{ error: any }>
    ) => {
      return {
        ...state,
        errorMessage: action.payload.error.responseStatus.message,
        buttonEnabled: true,
        buttonText: "Descargar",
      };
    },
    [getEmisionesDeComisionesInited.toString()]: (state) => {
      return {
        ...state,
        buttonEnabled: false,
        buttonComisionesText: "Descargando...",
      };
    },
    [getEmisionesDeComisionesCompleted.toString()]: (state) => {
      return {
        ...state,
        buttonEnabled: true,
        buttonComisionesText: "Descargar (Comisiones)",
      };
    },
    [getEmisionesDeComisionesFailed.toString()]: (
      state,
      action: Action<{ error: any }>
    ) => {
      return {
        ...state,
        errorMessage: action.payload.error.responseStatus.message,
        buttonEnabled: true,
        buttonComisionesText: "Descargar (Comisiones)",
      };
    },
    [setFechaDesde.toString()]: (
      state,
      action: Action<{ fechaDesdeSelected: FechaField }>
    ) => {
      return {
        ...state,
        fechaDesdeSelected: action.payload.fechaDesdeSelected,
      };
    },
    [setFechaHasta.toString()]: (
      state,
      action: Action<{ fechaHastaSelected: FechaField }>
    ) => {
      return {
        ...state,
        fechaHastaSelected: action.payload.fechaHastaSelected,
      };
    },
  },
  getEmisionesInitialState
);

const getEmisiones = (data: DateRange) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getEmisionesInited(data));
      const response = await services.api.reportes().getEmisiones(data);

      downloadFromUrl(response.url);

      dispatch(getEmisionesCompleted());
    } catch (error) {
      console.error(error);
      dispatch(getEmisionesFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al descargar el reporte. Intente nuevamente."
        )
      );
    }
  };
};

const getEmisionesDeComisiones = (data: DateRange) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getEmisionesDeComisionesInited(data));
      const response = await services.api
        .reportes()
        .getEmisionesDeComisiones(data);

      downloadFromUrl(response.url);

      dispatch(getEmisionesDeComisionesCompleted());
    } catch (error) {
      console.error(error);
      dispatch(getEmisionesDeComisionesFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al descargar el reporte. Intente nuevamente."
        )
      );
    }
  };
};

export {
  getEmisiones,
  getEmisionesDeComisiones,
  getEmisionesReducer,
  setFechaDesde,
  setFechaHasta,
};
